import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('serviceIntervalsForm');

    return {
        HELPER: t('helper'),
        INTERVALS_UNAVAILABLE: t('intervalsUnavailable'),
        NO_PARTS: t('noParts'),
        READ_ONLY: t('readOnly')
    };
};

export default useTranslation;
